<template>
  <modal v-if="modalData.show" @close="closeModal">
    <template slot="header">
      <md-button
        class="md-simple md-just-icon md-round modal-default-button"
        @click="closeModal"
      >
        <md-icon>clear</md-icon>
      </md-button>
    </template>

    <template slot="body">
      <p v-html="confirmText"></p>
    </template>

    <template slot="footer">
      <md-button class="md-simple" @click="closeModal">{{
        btnCancelText
      }}</md-button>
      <md-button class="md-success md-simple" @click="confirm">{{
        btnOkText
      }}</md-button>
    </template>
  </modal>
</template>

<script>
import { Modal } from "@/components";
import i18n from "../../lang/i18n";
export default {
  name: "ConfirmModal",
  components: {
    Modal
  },
  props: {
    modalData: {
      type: Object
    },
    confirmText: {
      type: String,
      default: i18n.t("modal.confirm_text")
    },
    btnOkText: {
      type: String,
      default: i18n.t("modal.ok")
    },
    btnCancelText: {
      type: String,
      default: i18n.t("modal.cancel")
    }
  },
  methods: {
    closeModal() {
      this.$emit("closeModal", this.modalData);
    },
    confirm() {
      this.$emit("confirm", this.modalData);
    }
  }
};
</script>

<style scoped></style>
